import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Profile/Preferences/preferences.container"
    ).then((module) => ({
        default: module.ProfilePreferencesContainer
    }))
);
